/**
 * C-5 — rótulo humano de um tempo de lembrete, em UM lugar.
 *
 * Estava dentro da `LembreteConfigTab`. A tela de Tipos de atividade passou a
 * mostrar o mesmo número, e duas formatações do mesmo valor divergem na
 * primeira mudança — é a família de erro do C-1 desta mesma rodada.
 */
export function rotuloMinutos(min: number): string {
  if (min % 1440 === 0) return `${min / 1440} dia${min / 1440 > 1 ? 's' : ''} antes`;
  if (min % 60 === 0) return `${min / 60} hora${min / 60 > 1 ? 's' : ''} antes`;
  return `${min} minutos antes`;
}

/** O que a tela mostra quando o tipo não tem padrão — texto único. */
export const SEM_LEMBRETE_PADRAO = 'sem lembrete padrão';
